var favouriteCarManager = (function () {

    var key = `${ENV.market}.favorites`;

    function init() {
        $(document).ready(function () {
            handleFavouriteClick();
            updateFavouriteViewer();
        });
    }

    function updateFavouriteViewer() {
        var navElem = $(".nav-favourite");
        var favourites = JSON.parse(localStorage.getItem(key)) || [];

        favourites.forEach(function (favourite) {

            const $btn  = $(".favourite-btn[data-id='" + favourite + "']");
            if (!$btn.length) return;

            const $icon = $btn.find('.favourite-icon');

            // ✅ NON toggle → imposto stato corretto
            $btn.attr('aria-pressed', 'true');
            $btn.attr('aria-label', LABELS?.favourites?.remove || 'Rimuovi dai preferiti');

            $icon.attr('src', '/assets/img/favourite/heart-filled.svg');

        });

        if (favourites.length) {
            $.each(navElem, function (i, ne){
                $(ne).css("display","")
                $(ne).attr('data-favourite-badge', favourites.length);
            })

        } else {
            $.each(navElem, function (i, ne){
                $(ne).css("display","none")
            })

        }
    }

    function handleFavouriteClick() {

        $(document).on("click", ".favourite-btn", function (e) {
            var favourites = JSON.parse(localStorage.getItem(key)) || [];

            const $btn  = $(this);
            const $icon = $btn.find('.favourite-icon');

            const isPressed = $btn.attr('aria-pressed') === 'true';
            const newState  = !isPressed;

            $btn.attr('aria-pressed', newState ? 'true' : 'false');
            $btn.attr(
                'aria-label',
                newState
                    ? LABELS?.favourites?.remove || 'Rimuovi dai preferiti'
                    : LABELS?.favourites?.add || 'Aggiungi ai preferiti'
            );

            $icon.attr('src',
                newState
                    ? '/assets/img/favourite/heart-filled.svg'
                    : '/assets/img/favourite/heart-outline.svg'
            );

            var carID = $btn.data('id');
            if (!carID) return;

            var index = favourites.indexOf(carID);

            if (newState && index === -1) {
                favourites.push(carID);
            }

            if (!newState && index !== -1) {
                favourites.splice(index, 1);
            }

            // store array in local storage
            localStorage.setItem(key, JSON.stringify(favourites));
            updateFavouriteViewer();
            if (ENV.isFavouritePage !== "" && ENV.isFavouritePage === "1") {
                $(".form-filter").submit();
            }
            e.preventDefault();
            window.stop()
            return false;
        });
    }

    return {
        init: init,
        updateFavouriteViewer: updateFavouriteViewer
    };

})(jQuery);
